import { render, staticRenderFns } from "./BaseTableDetailRow.vue?vue&type=template&id=7989120b&scoped=true&"
import script from "./BaseTableDetailRow.vue?vue&type=script&lang=js&"
export * from "./BaseTableDetailRow.vue?vue&type=script&lang=js&"
import style0 from "./BaseTableDetailRow.vue?vue&type=style&index=0&id=7989120b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7989120b",
  null
  
)

export default component.exports